import React from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import { currencyFormatter } from '../../utils/functions'
import Typography from '../Typography'
import classes from './senior-portrait-option-item.module.sass'
import appointmentClasses from '../appointment-option/appointment-option.module.sass'
import Button from '../Button'
import PoseImg from '../pose-img'
import { routes } from '../../routes'

const SeniorPortraitOptionItem = ({ packageOption, background, favorites }) => {
  const poseText = (numPoses) => {
    if (numPoses === 1) return `Choose ${numPoses} pose`

    return `Choose Up to ${numPoses} poses`
  }

  if (packageOption.prices.length === 0) return null

  const params = {
    opt: packageOption.id,
    favs: favorites.map((favorite) => favorite.id),
  }

  return (
    <div className={cn(classes.container, packageOption.bestValue ? classes.bestValue : '')}>
      <div className={classes.left}>
        {packageOption.imageUrl && !packageOption.imageUrl.toLowerCase().includes('missing.png') ? (
          <img src={packageOption.imageUrl} />
        ) : (
          <PoseImg numPoses={packageOption.poses} favorites={favorites} background={background} />
        )}
      </div>
      <div className={classes.right}>
        <div className={classes.header}>
          <Typography weight="bold">
            {packageOption.name.trim()}
          </Typography>
          <Typography tag="span">{currencyFormatter(packageOption.prices[0].price)}</Typography>
        </div>
        {packageOption.tagline && <div style={{ fontStyle: 'italic' }}>{packageOption.tagline}</div>}
        <Typography weight="bold" classes={classes.poseText}>
          {packageOption.name.toLowerCase().includes('yearbook') ? 'Select Yearbook Pose' : poseText(packageOption.poses)}
        </Typography>
        <ul className={cn(appointmentClasses.imageTypeList, classes.imageList)}>
          {packageOption
            .imageTypes
            .map((imageType) => <li key={imageType.name}>{imageType.name}</li>)
          }
        </ul>
        <Link to={routes.packageBuilder(packageOption.packageId, params)}>
          <Button
            fullWidth
            rounded
            variant={packageOption.bestValue ? 'submit' : 'primary'}
          >
            Add to Cart
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default SeniorPortraitOptionItem
